import React, { useState } from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import imgHeroMobile from '../i/bg-our-food-mobile.jpg';
//import arrow from '../../../../../assets/images/hero-arrow.png';
import Collapsible from '../../../../../components/Collapsible/Collapsible';
import imgOurProteins from '../i/bg-proteins_mb.jpg';
import imgBeefGuarantee from '../i/bg-beef-guarantee.jpg';
import imgChickenGuarantee from '../i/bg-chicken-guarantee.jpg';
import imgEggsGuarantee from '../i/bg-eggs-guarantee.jpg';
import imgPorkGuarantee from '../i/bg-pork-guarantee.jpg';
import imgBeyondMeat from '../i/bg-beyond-meat.jpg';
import imgOurProduce from '../i/bg-produce_mb.jpg';
import imgTomatoes from '../i/bg-tomatoes.jpg';
import imgOnions from '../i/bg-onions.jpg';
import imgLettuce from '../i/bg-lettuce.jpg';
import imgCheese from '../i/bg-cheese.jpg';
import imgOurDrinks from '../i/bg-drinks_mb.jpg';
import imgRootbeer from '../i/bg-rootbeer.jpg';
import imgCoffee from '../i/bg-coffee.jpg';
//import useToggle from '../../../../../hooks/Toggle/useToggle';



const Mobile = (props) => {
    const [fadeLayer, setFadeLayer] = useState(false);

    const handleToggleFade = (bool) => {
        setFadeLayer(bool);
        //setFadeLayer((prevState => !prevState));
        console.log('click fade layer');
    }
    return (

        <>
            <div className="blockwrap our-food-pages home-our-food">
                <div className={`fade-layer ${fadeLayer && 'fade-on'}`}></div>

                <div className="intro-block">
                        <img className="intro-bg-img" src={imgHeroMobile} alt="hero" />
                </div>

                <div className="copy-block">
                 
                    {props.lang === 'en' && <h1><span><span className="line"></span> Our <span className="line"></span></span>Food</h1> }
                    {props.lang === 'fr' && <h1><span><span className="line"></span> Nos <span className="line"></span></span>INGRÉDIENTS</h1> }
                    {props.lang === 'en' && <p>We’re on a journey to source simple, great-tasting ingredients farmed with care.</p>}
                    {props.lang === 'fr' && <p>Nous nous sommes donné comme mission de vous offrir des ingrédients de premier choix, produits de la meilleure manière qui soit.</p>}
                    
                </div>

            </div> 

            <div className="blockwrap ingredients-info-wrap">
                <Collapsible 
                    title={props.lang !== 'fr' ? 'Proteins': 'Protéines'} 
                    theImg={imgOurProteins} 
                    // fadeIt={this.fadeIt} 
                    handleToggleFade={handleToggleFade}
                    fadeLayer={fadeLayer} 
                    
                >
                    <Link to={`/${props.lang}/our-values/our-food/beef`} className="page-link">
                        <img className="beef-mb" src={imgBeefGuarantee} alt="beef guarantee" />
                        {props.lang === 'en' && <h2><span className="our"><span className="line"></span>Our<span className="line"></span></span><br />Beef</h2>}
                        {props.lang === 'fr' && <h2><span className="our"><span className="line"></span>Notre<span className="line"></span></span><br />Bœuf</h2>}
                    </Link>
                    <Link to={`/${props.lang}/our-values/our-food/chicken`} className="page-link">
                        <img className="chicken-mb" src={imgChickenGuarantee} alt="chicken guaranttee" />
                        {props.lang === 'en' && <h2><span className="our"><span className="line"></span>Our<span className="line"></span></span><br />Chicken</h2>}
                        {props.lang === 'fr' && <h2><span className="our"><span className="line"></span>Notre<span className="line"></span></span><br />Poulet</h2>}
                    </Link>
                    <Link to={`/${props.lang}/our-values/our-food/eggs`} className="page-link">
                        <img className="eggs-mb" src={imgEggsGuarantee} alt="egg guarantee" />
                        {props.lang === 'en' && <h2><span className="our"><span className="line"></span>Our<span className="line"></span></span><br />Eggs</h2>}
                        {props.lang === 'fr' && <h2><span className="our"><span className="line"></span>Nos<span className="line"></span></span><br />Œufs</h2>}
                    </Link>
                    <Link to={`/${props.lang}/our-values/our-food/pork`} className="page-link">
                        <img className="pork-mb" src={imgPorkGuarantee} alt="pork guarantee" />
                        {props.lang === 'en' && <h2><span className="our"><span className="line"></span>Our<span className="line"></span></span><br />Pork</h2>}
                        {props.lang === 'fr' && <h2><span className="our"><span className="line"></span>Notre<span className="line"></span></span><br />Porc</h2>}
                    </Link>
                    <Link to={`/${props.lang}/our-values/our-food/beyond-meat`} className="page-link">
                        <img className="beyond-meat-mb" src={imgBeyondMeat} alt="beyond meat" />
                        {props.lang === 'en' && <h2>Beyond Meat</h2>}
                        {props.lang === 'fr' && <h2>Beyond Meat<sup className="menu-dagger">†</sup></h2>}
                    </Link>
                 
                </Collapsible>
                <Collapsible
                    title={props.lang !== 'fr' ? 'Produce': 'Garnitures et Accompagnements'} 
                    theImg={imgOurProduce} 
                    handleToggleFade={handleToggleFade}
                    fadeLayer={fadeLayer} 
                >
                    <Link to={`/${props.lang}/our-values/our-food/tomatoes`} className="page-link">
                        <img className="beef-mb" src={imgTomatoes} alt="tomatos" />
                        {props.lang === 'en' && <h2><span className="our"><span className="line"></span>Our<span className="line"></span></span><br />Tomatoes</h2>}
                        {props.lang === 'fr' && <h2><span className="our"><span className="line"></span>Nos<span className="line"></span></span><br />Tomates</h2>}
                    </Link>
                    <Link to={`/${props.lang}/our-values/our-food/onions`} className="page-link">
                        <img className="beef-mb" src={imgOnions} alt="onions" />
                        {props.lang === 'en' && <h2><span className="our"><span className="line"></span>Our<span className="line"></span></span><br />Onions</h2>}
                        {props.lang === 'fr' && <h2><span className="our"><span className="line"></span>Nos<span className="line"></span></span><br />Oignions</h2>}
                    </Link>
                    <Link to={`/${props.lang}/our-values/our-food/lettuce`} className="page-link">
                        <img className="lettuce-mb" src={imgLettuce} alt="lettuce" />
                        {props.lang === 'en' && <h2><span className="our"><span className="line"></span>Our<span className="line"></span></span><br />Lettuce</h2>}
                        {props.lang === 'fr' && <h2><span className="our"><span className="line"></span>Notre<span className="line"></span></span><br />Laitue</h2>}
                    </Link>
                    <Link to={`/${props.lang}/our-values/our-food/cheese`} className="page-link">
                        <img className="cheese-mb" src={imgCheese} alt="cheese" />
                        {props.lang === 'en' && <h2><span className="our"><span className="line"></span>Our<span className="line"></span></span><br />Cheese</h2>}
                        {props.lang === 'fr' && <h2><span className="our"><span className="line"></span>Notre<span className="line"></span></span><br />Fromage</h2>}
                    </Link>
                
                </Collapsible>
                <Collapsible
                    title={props.lang !== 'fr' ? 'Drinks' : 'Boissons'} 
                    theImg={imgOurDrinks} 
                    handleToggleFade={handleToggleFade}
                    fadeLayer={fadeLayer} 
                >
                    <Link to={`/${props.lang}/our-values/our-food/rootbeer`} className="page-link">
                        <img className="rootbeer-mb" src={imgRootbeer} alt="root beer" />
                        {props.lang === 'en' && <h2><span className="our"><span className="line"></span>Our<span className="line"></span></span><br />Root Beer</h2>}
                        {props.lang === 'fr' && <h2><span className="our"><span className="line"></span>Notre<span className="line"></span></span><br />Root Beer</h2>}
                    </Link>
                    <Link to={`/${props.lang}/our-values/our-food/coffee`} className="page-link">
                        <img className="rootbeer-mb" src={imgCoffee} alt="coffee" />
                        {props.lang === 'en' && <h2><span className="our"><span className="line"></span>Our<span className="line"></span></span><br />Coffee</h2>}
                        {props.lang === 'fr' && <h2><span className="our"><span className="line"></span>Notre<span className="line"></span></span><br />Café</h2>}
                    </Link>

                </Collapsible>

            </div>
        </>

    )

}
export default Mobile;